import { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

import Input from "../campaign/wizard/Input";
import { LIST_LIMIT_OPTIONS } from "../../constants/listFilters";

function LimitField({ limit, onLimitChange, className = "w-[3rem] shrink-0" }) {
    return (
        <Input
            as="select"
            size="sm"
            label="Show"
            labelIcon="list-ul"
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            options={LIST_LIMIT_OPTIONS.map((value) => ({
                value,
                label: `${value}`,
            }))}
            wrapperClassName={className}
        />
    );
}

function DateFields({
    startDate,
    onStartDateChange,
    endDate,
    onEndDateChange,
    className = "",
}) {
    return (
        <div className={`flex items-end gap-3 ${className}`.trim()}>
            <Input
                type="date"
                size="sm"
                label="From"
                labelIcon="calendar-event"
                value={startDate}
                onChange={(e) => onStartDateChange(e.target.value)}
                wrapperClassName="w-full sm:w-[10rem] sm:shrink-0"
            />
            <Input
                type="date"
                size="sm"
                label="To"
                labelIcon="calendar-check"
                value={endDate}
                onChange={(e) => onEndDateChange(e.target.value)}
                min={startDate || undefined}
                wrapperClassName="w-full sm:w-[10rem] sm:shrink-0"
            />
        </div>
    );
}

export default function FilterBar({
    limit,
    onLimitChange,
    startDate,
    onStartDateChange,
    endDate,
    onEndDateChange,
}) {
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <>
            <div className="mb-4 md:hidden">
                {!mobileOpen ? (
                    <button
                        type="button"
                        className="inline-flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
                        aria-expanded={false}
                        onClick={() => setMobileOpen(true)}
                    >
                        <i className="bi bi-funnel" aria-hidden />
                        Filter
                    </button>
                ) : (
                    <div className="rounded-xl border border-slate-200 bg-white p-3">
                        <div className="mb-3 flex justify-end">
                            <button
                                type="button"
                                className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 transition hover:text-slate-900"
                                aria-expanded={true}
                                onClick={() => setMobileOpen(false)}
                            >
                                <i className="bi bi-chevron-up" aria-hidden />
                                Hide
                            </button>
                        </div>
                        <div className="flex flex-col gap-3">
                            <LimitField
                                limit={limit}
                                onLimitChange={onLimitChange}
                                className="w-full"
                            />
                            <DateFields
                                startDate={startDate}
                                onStartDateChange={onStartDateChange}
                                endDate={endDate}
                                onEndDateChange={onEndDateChange}
                                className="flex-col items-stretch"
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className="mb-4 hidden rounded-xl border border-slate-200 bg-white p-3 md:block">
                <div className="flex items-end justify-between gap-4">
                    <LimitField limit={limit} onLimitChange={onLimitChange} />
                    <DateFields
                        startDate={startDate}
                        onStartDateChange={onStartDateChange}
                        endDate={endDate}
                        onEndDateChange={onEndDateChange}
                    />
                </div>
            </div>
        </>
    );
}
